// extracted by mini-css-extract-plugin
export default {"loader-container":"LoadingIndicator_loader-container__bUMsJ"};